export default class OnFileChanged {
  constructor($parse) {
    'ngInject';

    this.restrict = 'A';
    Object.assign(this, { $parse });
  }

  link($scope, element, attrs) {
    const attrHandler = this.$parse(attrs.onFileChanged);

    const handler = (e) => {
      $scope.$apply(() => {
        attrHandler($scope, { $event: e, files: e.target.files });
      });
    };

    element[0].addEventListener('change', handler, false);
  }

  static directiveFactory($parse) {
    'ngInject';

    return new OnFileChanged($parse);
  }
}



// WEBPACK FOOTER //
// ./common/directives/on-file-changed.js